module.exports = __webpack_public_path__ + "front/img/18_b.1ae3c226.png";